module.exports = __webpack_public_path__ + "static/media/logo.985560c3.webp";